import _ from 'lodash';

import { UnderwritingSubtab } from 'constants/loanApplication';

import { BORROWING_ENTITY_TABS_HREF } from '../../tabs/borrowers/EditEntityModal/EditEntityModal.constants';
import { FINANCIAL_INFO_VIEWS_PATHS } from '../../tabs/financialInfo/FinancialInfo.constants';
import {
  ENTITY_TYPE_HREF_MAP,
  LOAN_AND_LOCK_SECTION_NAME_MAP,
  PROPERTY_SECTION_NAME_MAP,
} from '../../tabs/propertyAndLoan/EditModal/EditModal.constants';

export const FinancialInfoViewName = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: 'Income & Employment',
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: 'Liabilities',
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: 'REO',
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: 'Assets',
};

export const UnderwritingSubtabName = Object.values(UnderwritingSubtab).map(
  ({ tabName, tabRoute }) => ({
    subtabRoute: tabRoute,
    label: tabRoute === 'Underwriting' ? 'Underwriting Summary' : tabName,
  }),
);

const BorrowerEditSectionLabelOverride = {
  [BORROWING_ENTITY_TABS_HREF.BORROWER]: 'Personal Info',
  [BORROWING_ENTITY_TABS_HREF.ADDRESS]: 'Address History',
  [BORROWING_ENTITY_TABS_HREF.POA]: 'Power of Attorney',
};

export const BorrowerEditSectionName = Object.values(BORROWING_ENTITY_TABS_HREF).map(href => ({
  sectionHref: href,
  label: BorrowerEditSectionLabelOverride[href] ?? _.startCase(href),
}));

export const EntityDrawerSectionNameMap = {
  [ENTITY_TYPE_HREF_MAP.PROPERTY_INFO]: PROPERTY_SECTION_NAME_MAP,
  [ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK]: LOAN_AND_LOCK_SECTION_NAME_MAP,
};
